// T22.355 (Kelly 2026-10-16): "when I click Open it takes me to what appears
// to be nothing broken". The row click only switched segment + pane; the pane
// it landed on had no idea WHICH media was broken, so the Segment Fill section
// stayed collapsed with nothing flagged. This tiny shared store carries the
// clicked row from the indicator to the section that owns that media (today:
// SegmentFillUnified for `segment_fill` rows), and records rows the user fixed
// in-session so the indicator drops them without waiting for a reload.
import { useSyncExternalStore } from "react";

let state = { focus: null, resolvedIds: [] };
const listeners = new Set();

function emit(next) {
  state = next;
  listeners.forEach((l) => l());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setBrokenMediaFocus(item) {
  emit({ ...state, focus: item || null });
}

export function clearBrokenMediaFocus() {
  if (state.focus) emit({ ...state, focus: null });
}

export function markBrokenMediaResolved(id) {
  if (id == null || state.resolvedIds.includes(id)) return;
  emit({
    focus: state.focus && state.focus.id === id ? null : state.focus,
    resolvedIds: [...state.resolvedIds, id],
  });
}

export function resetBrokenMediaFocus() {
  emit({ focus: null, resolvedIds: [] });
}

export function useBrokenMediaFocus() {
  return useSyncExternalStore(subscribe, () => state.focus);
}

export function useResolvedBrokenMediaIds() {
  return useSyncExternalStore(subscribe, () => state.resolvedIds);
}

// The focused row when it names THIS segment's fill, else null.
export function segmentFillFocus(focus, segmentId) {
  if (!focus || focus.kind !== "segment_fill" || segmentId == null) return null;
  return String(focus.segment_id) === String(segmentId) ? focus : null;
}
